import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferBlock() {
  const SHOPIFY_CHECKOUT_URL = 'https://hoypleno.com/cart/44176501375062:1';
  const handleBuyClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Legado en Vida Kit',
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    // Pequeño delay para que el pixel se dispare antes de redirigir
    setTimeout(() => {
      window.location.href = SHOPIFY_CHECKOUT_URL;
    }, 300);
  };
  return <section id="offer" className="py-20 md:py-32 px-6 bg-cream" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="bg-card rounded-3xl p-8 md:p-16 shadow-warm-lg border-2 border-gold/30 text-center relative overflow-hidden" data-id="element-130">
            {/* Decorative corner accents */}
            <div className="absolute top-0 left-0 w-24 h-24 bg-gradient-to-br from-sage/10 to-transparent rounded-br-full" data-id="element-131"></div>
            <div className="absolute bottom-0 right-0 w-24 h-24 bg-gradient-to-tl from-terracotta/10 to-transparent rounded-tl-full" data-id="element-132"></div>

            <div className="relative z-10" data-id="element-133">
              <h2 className="font-serif text-2xl md:text-3xl text-charcoal mb-4" data-id="element-134">
                Obtenga el Kit Completo
              </h2>
              <h3 className="font-serif text-3xl md:text-4xl text-sage font-bold mb-10" data-id="element-135">
                "Legado en Vida: El Kit de No Me Olvides"
              </h3>

              <div className="mb-8" data-id="element-136">
                <span className="text-lg text-muted block mb-2" data-id="element-137">
                  Por un pago único de solo
                </span>
                <span className="text-6xl md:text-7xl font-serif text-charcoal font-bold block mb-4" data-id="element-138">
                  $6.39{' '}
                  <span className="text-2xl text-muted font-sans font-normal" data-id="element-139">
                    USD
                  </span>
                </span>
                <p className="text-terracotta font-medium text-lg" data-id="element-140">
                  Es menos de lo que cuesta una cena, pero el valor de la paz
                  mental para su familia no tiene precio.
                </p>
              </div>

              <div className="flex flex-col items-center gap-6 mt-12" data-id="element-141">
                <Button className="w-full md:w-auto text-lg md:text-xl px-10 py-5" onClick={handleBuyClick} data-id="element-142">
                  QUIERO PROTEGER A MI FAMILIA AHORA
                </Button>

                <div className="flex items-center gap-2 text-muted text-sm md:text-base" data-id="element-143">
                  <ShieldCheckIcon className="w-5 h-5 text-sage" data-id="element-144" />
                  <span data-id="element-145">
                    Compra 100% segura. Descarga inmediata tras el pago.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}